import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/swiper-bundle.css";
const stats = [
  { number: "25+ Cities", label: "Targeted" },
  { number: "58,000+", label: "Test Takers" },
  { number: "23,000+", label: "Test Attempted" },
  { number: "1291+", label: "Winners" },
  { number: "Rs1* Crore", label: "Awarded" },
  { number: "23,000+", label: "Families Empowered" },
  { number: "6 Inclusive", label: "Scholarship Categories" },
  { number: "1.35 Lakh Free", label: "Mentorship Sessions" },
];

const EventsQuickFacts = () => {
  return (
    <div className="w-full max-md:w-full bg-[#F7F7F7] py-10">
      <div className="flex flex-col   container gap-6 w-full mx-auto ">
        <h3 className="text-5xl leading-[42px] text-[#173CBA] font-light  capitalize  max-md:text-center">
          About College Mentor{" "}
          <span className="text-[#173CBA] font-semibold">Scholarship Test</span>
        </h3>

        <div className="flex flex-wrap max-md:hidden justify-center gap-[38px] text-center text-[#383838]  ">
          {stats.map((item, index) => (
            <div
              key={index}
              className="flex flex-col justify-center items-center gap-[15px] p-[10px] border border-[#A3A2AC] bg-white"
            >
              <span className="text-[32px] font-semibold leading-[42px] capitalize">
                {item.number}
              </span>
              <span className="text-[24px] font-light leading-[42px] capitalize">
                {item.label}
              </span>
            </div>
          ))}
        </div>
        <div className="md:hidden">
          <Swiper
            modules={[Autoplay]}
            autoplay={{ delay: 2500 }}
            spaceBetween={20}
            slidesPerView={1}
            loop={true}
          >
            {stats.map((item, index) => (
              <SwiperSlide key={index}>
                <div className="flex flex-col max-md:w-fit max-md:mx-auto justify-center items-center gap-[15px] p-[10px] border border-[#A3A2AC] bg-white text-[#383838] text-center">
                  <span className="text-[32px] font-light leading-[42px] capitalize">
                    {item.number}
                  </span>
                  <span className="text-[24px] font-semibold leading-[42px] capitalize">
                    {item.label}
                  </span>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default EventsQuickFacts;
